import ObjectListStore from "./ObjectList";
import {action, observable} from "mobx";

class UsersManager extends ObjectListStore {
  constructor(api) {
    super(api);
    this.setData(this.DEFAULT);
    this.baseUrl = '/users';
    this.headers = [
      {name: 'id', label: 'ID', highlight: true},
      {name: 'username', label: 'Username', highlight: true},
      {name: 'info.nickname', label: 'Name', shrink: true},
      {name: 'phone', label: 'Phone No.'},
      {name: 'email', label: 'Email'},
      {name: '_scopes', label: 'Role'},
      {name: 'actions', label: ''},
    ];
  }

  @observable groups = {};

  @action
  listByGroup() {
    this.api.get(`/users/group`).then(res => {
      if (res.ok) {
        this.groups = res.data;
      } else {
        this.groups = {};
      }
    });
  }

  @action
  addUser(user, cb) {
    if (!user) return;

    this.api.post("/users", user).then(res => {
      if (cb) cb(res);
    })
  }

  @action
  editUser(user, cb) {
    if (!user) return;

    this.api.put(`/users/${user.id}`, user).then(res => {
      if (cb) cb(res);
    })
  }

  @action
  removeUser(userId, hard, cb) {
    this.api.delete(`/users/${userId}`, {hard}).then(res => {
      if (cb) cb(res);
    })
  }

  @action
  resetPassword(userId, type, password, send_email, auth_password, cb) {
    const data = {
      password,
      auth_password
    };
    this.api.post(`users/${userId}/reset-password`, data, {params: {type, send_email}}).then(res => {
      if (cb) cb(res);
    })
  }
}

export default UsersManager;